<template>
  <el-container class="bigMain" :class="{ 'bigMain-mobile': isMobile }">
    <div v-if="isMobile" class="Dsr-logo">
      <TheLogo></TheLogo>
    </div>
    <el-header v-else>
      <The-header></The-header>
    </el-header>
    <el-main>
      <div class="problem-feedback">
        <div class="title">贝壳-隐私问题反馈</div>
        <div class="problem-feedback-content">
          <div class="problem-feedback-content-left" v-if="!sign">
            <p class="link" :class="tag === 1 ? 'active' : 'lose'">
              <a :class="tag === 1 ? 'active' : 'lose'" @click="jump(1)">
                <span
                  class="icon"
                  :style="{
                    color: step >= 1 ? '#0076FC' : 'transparent',
                    background:
                      step >= 2
                        ? `center center / 75% 40% no-repeat url(${'/dsr/success.png'}) #0076FC`
                        : '',
                    border: step >= 1 ? 'transparent' : '',
                  }"
                >
                </span>
                1.选择产品
              </a>
            </p>
            <p class="link" :class="tag === 2 ? 'active' : 'lose'">
              <a :class="tag === 2 ? 'active' : 'lose'" @click="jump(2)">
                <span
                  class="icon"
                  :style="{
                    color: step >= 2 ? '#0076FC' : 'transparent',
                    background:
                      step >= 3
                        ? `center center / 75% 40% no-repeat url(${'/dsr/success.png'}) #0076FC`
                        : '',
                    border: step >= 2 ? 'transparent' : '',
                  }"
                >
                </span>
                2.选择问题类型
              </a>
            </p>
            <p class="link" :class="tag === 3 ? 'active' : 'lose'">
              <a :class="tag === 3 ? 'active' : 'lose'" @click="jump(3)">
                <span
                  class="icon"
                  :style="{
                    color:
                      step >= 3
                        ? '#0076FC'
                        : 'transparent' || tag === 3
                        ? '#0076FC'
                        : 'transparent',
                    background:
                      step >= 4
                        ? `center center / 75% 40% no-repeat url(${'/dsr/success.png'}) #0076FC`
                        : '',
                    border: step >= 3 ? 'transparent' : '',
                  }"
                >
                </span>
                3.反馈留资
              </a>
            </p>
            <span class="line1 line"></span>
            <span class="line2 line"></span>
          </div>
          <div class="problem-feedback-content-right">
            <router-view />
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import router from "../../router";
import store from "../../store";
export default {
  name: "PrivacyDsr",
  data() {
    return {
      list: [
        {
          id: 1,
          title: "1.选择产品",
          path: "/dsr/product",
        },
        {
          id: 2,
          title: "2.选择问题类型",
          path: "/dsr/type",
        },
        {
          id: 3,
          title: "3.反馈留资",
          path: "/dsr/capital-retention",
        },
      ],
    };
  },
  computed: {
    step() {
      return this.$store.state.app.step;
    },
    tag() {
      return this.$store.state.app.tag;
    },
    sign() {
      return this.$store.state.app.sign;
    },
  },
  methods: {
    jump(id) {
      if (id === 1 && this.step >= id) {
        this.$store.commit("app/CHANGE_TAG", id);
        this.$router.push("/dsr/product");
      }
      if (id === 2 && this.step >= id) {
        this.$store.commit("app/CHANGE_TAG", id);
        this.$router.push("/dsr/type");
      }
      if (id === 3 && this.step >= id) {
        this.$store.commit("app/CHANGE_TAG", id);
        this.$router.push("/dsr/capital-retention");
      }
    },
    getlocalstorage(key, Exp) {
      let data = localStorage.getItem(key);
      let newdata = JSON.parse(data);
      if (!data) {
        return;
      }
      if (new Date().getTime() - newdata.time > Exp) {
        localStorage.removeItem(key);
        return;
      } else {
        return localStorage.getItem(key);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    function getlocalstorage(key, Exp) {
      let data = localStorage.getItem(key);
      let newdata = JSON.parse(data);
      if (!data) {
        return;
      }
      if (new Date().getTime() - newdata.time > Exp) {
        localStorage.removeItem(key);
        return;
      } else {
        return localStorage.getItem(key);
      }
    }
    let path = ["/privacy-attestation", "/verification"];
    if (
      path.find((item) => item === from.path) ||
      getlocalstorage("token", 60 * 1000 * 20)
    ) {
      next();
    } else if (isMobile) {
      router.push("/verification");
    } else {
      router.push("/privacy-attestation");
      store.commit("app/CHANGE_STATUS", true);
    }
  },
};
</script>

<style lang="scss" scoped>
.bigMain {
  width: 100%;
  height: 100%;
}
.problem-feedback {
  width: calc($multiple * 1040px);
  margin: auto;
  margin-top: 0;
  box-sizing: border-box;
  .title {
    font-size: calc($multiple * 0.24px * 75);
    height: calc($multiple * 0.86px * 75);
    line-height: calc($multiple * 0.86px * 75);
    border-bottom: calc($multiple * 1px) solid #ccc;
    backdrop-filter: blur(calc($multiple * 0.36px * 75));
  }
  .problem-feedback-content {
    display: flex;
    height: 100%;
    padding-top: calc($multiple * 0.56px * 75);
    .problem-feedback-content-left {
      position: relative;
      height: calc($multiple * 5.75px * 75);
      width: calc($multiple * 2.7px * 75);
      margin-right: calc($multiple * 0.46px * 75);
      border-radius: calc($multiple * 2px);
      border: calc($multiple * 1px) solid rgba(0, 0, 0, 0.15);
      .link {
        position: relative;
        height: calc($multiple * 0.67px * 75);
        line-height: calc($multiple * 0.67px * 75);
        display: flex;
        font-size: calc($multiple * 0.215px * 75) !important;
        a {
          font-size: calc($multiple * 0.215px * 75) !important;
          .icon {
            background: none;
            border: calc($multiple * 1px) solid #ccc;
          }
        }
        .icon {
          position: absolute;
          width: calc($multiple * 0.25px * 75);
          height: calc($multiple * 0.25px * 75);
          top: calc($multiple * 0.2px * 75);
          left: calc($multiple * 0.23px * 75);
          border-radius: calc($multiple * 0.125px * 75);
          position: absolute;
          border: calc($multiple * 1px) solid rgba(0, 0, 0, 0.15);
        }
        .el-icon-success {
          position: absolute;
          left: calc($multiple * -0.05px * 75);
          top: calc($multiple * -0.2px * 75);
          font-size: calc($multiple * 0.25px * 75) !important;
          text-align: center;
        }
      }
      .line {
        position: absolute;
        width: calc($multiple * 1px);
        height: calc($multiple * 0.35px * 75);
        left: calc($multiple * 0.35px * 75);
        background-color: rgba(0, 0, 0, 0.15);
      }
      .line1 {
        top: calc($multiple * 0.48px * 75);
      }
      .line2 {
        top: calc($multiple * 1.16px * 75);
      }
      p {
        line-height: calc($multiple * 0.5px * 75);
        padding-left: calc($multiple * 0.5px * 75);
        a {
          font-size: calc($multiple * 0.3px * 75);
          padding-left: calc($multiple * 0.2px * 75);
          color: #aaa;
        }
      }
    }
    .active {
      color: rgba(0, 0, 0, 0.65) !important;
      .icon {
        background: #0076fc !important;
        border: calc($multiple * 1px) solid #ccc !important;
      }
    }
    .lose {
      .icon {
        border: calc($multiple * 1px) solid #ccc !important;
      }
    }
    .problem-feedback-content-right {
      width: calc($multiple * 10px * 75);
    }
  }
}
.bigMain-mobile {
  display: flex;
  flex-direction: column;
  .Dsr-logo {
    height: 100%;
    display: flex;
    align-items: center;
    height: 2.56rem;
    background: #0072f5;
    backdrop-filter: blur(0.48rem);
    padding-left: 1.02rem;
  }
  .problem-feedback {
    padding: 0;
    width: 19.2rem;
    box-sizing: border-box;
  }
  .el-main {
    .title {
      display: none;
    }
    .problem-feedback-content {
      display: flex;
      height: 100%;
      flex-direction: column;
      padding-top: 0;
      padding: 0 1rem;
      .problem-feedback-content-left {
        display: flex;
        position: relative;
        justify-content: space-around;
        align-items: flex-end;
        height: 1.42rem;
        margin-top: 1.08rem;
        margin-right: 0;
        border: 0 !important;
        width: 100%;
        border-bottom: 0.053rem solid rgba(0, 0, 0, 0.06) !important;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        .line {
          display: none;
        }
        .link {
          position: relative;
          height: 0.67rem;
          line-height: 0.67rem;
          display: flex;
          padding-bottom: 1rem;
          border-bottom: 0.1rem solid transparent;
          a {
            font-size: 0.72rem !important;
          }
        }
        .el-icon-success {
          position: absolute;
          left: -0.05rem;
          top: -0.2rem;
          font-size: 0.25rem !important;
          text-align: center;
        }
        .link.active {
          border-bottom: 0.1rem solid #0072f5;
          color: rgba(0, 0, 0, 0.65) !important;
          .icon {
            background: #0076fc !important;
            border: 1px solid #ccc !important;
          }
        }
        .lose {
          .icon {
            border: 1px solid #ccc !important;
          }
        }
        p {
          line-height: 0.5rem;
          padding-left: 0.5rem;
          a {
            font-size: 0.3rem;
            padding-left: 0.2rem;
            color: #aaa;
          }
        }
        .icon {
          position: absolute;
          width: 0.81rem;
          height: 0.81rem;
          border-radius: 0.4rem;
          top: -0.1rem;
          left: -0.2rem;
          background: none;
        }
      }
      .problem-feedback-content-right {
        width: 100%;
      }
    }
  }
}
</style>
